/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-cycle */
import React, { useState, SetStateAction } from 'react';
import { Field, FieldProps, Form, Formik, FormikErrors } from 'formik';
import ReactDOM from 'react-dom';
import * as Yup from 'yup';
import 'bootstrap/dist/css/bootstrap.css';
import './requestingprovidermodal.component.css';
import { states } from '../../helper/stateList';
import { requestingproviderprops } from './requestingprovider.component';

interface RequestingProviderProps {
  item: requestingproviderprops;
  setrequestingProviderItem: React.Dispatch<SetStateAction<requestingproviderprops>>
  onClose: () => void;
}

interface FormValues {
  [key: string]: any,
  npi: number,
  taxId: number,
  firstName: string,
  lastName: string,
  groupName: string,
  facilityName: string,
  address: string,
  address2: string,
  city: string,
  state: string,
  zipCode: string,
  phone: string
}

const RequestingProviderModal: React.FC<RequestingProviderProps> = ({ item, setrequestingProviderItem, onClose }) => {
  const [taxId, setTaxId] = useState(item.taxId);
  const [npi, setNpi] = useState(item.npi);

  const handleTaxId = (event:any, form:any) => {
    const { value, name } = event.target;
    const newTaxId = value;
    const regex = /^[0-9]*$/;
    if (regex.test(newTaxId) || newTaxId === '') {
      setTaxId(newTaxId);
      form.setFieldValue(name, newTaxId);
    }
  };

  const handleNpi = (event:any, form:any) => {
    const { value, name } = event.target;
    const newNpi = value;
    const regex = /^[0-9]*$/;
    if (regex.test(newNpi) || newNpi === '') {
      setNpi(newNpi);
      form.setFieldValue(name, newNpi);
    }
  };

  const validationSchema = Yup.object().shape({
    taxId: Yup.number(),
    npi: Yup.number(),
    firstName: Yup.string(),
    lastName: Yup.string(),
    groupName: Yup.string(),
    address: Yup.string()
      .required('Please provide an Address'),
    address2: Yup.string(),
    city: Yup.string()
      .min(2, 'Must be at least 2 characters long')
      .required('Please provide a City'),
    state: Yup.string()
      .matches(/^[A-Za-z]{2}$/, { message: 'Only 2 letters are allowed', excludeEmptyString: true })
      .required('Please select a State'),
    zipCode: Yup.string()
      .matches(/^\d{5}$/, { message: 'Must be 5 digits', excludeEmptyString: true })
      .required('Please provide a Zip Code'),
    phone: Yup.string().required('Phone is required'),
  });

  const validate = (values:any) => {
    const errors:any = {};
    const nameRegex = /^[A-Za-z ]{2,}$/;

    if ((values.firstName || values.lastName) && values.facilityName) {
      errors.firstName = 'Either use First and Last Name or Facility Name';
      errors.lastName = 'Either use First and Last Name or Facility Name';
      errors.facilityName = 'Either use First and Last Name or Facility Name';
    } else if (!(values.firstName && values.lastName) && !values.facilityName) {
      errors.firstName = 'Either First and Last Name or Facility Name is required';
      errors.lastName = 'Either First and Last Name or Facility Name is required';
      errors.facilityName = 'Either First and Last Name or Facility Name is required';
    }

    if (values.firstName && !nameRegex.test(values.firstName)) {
      errors.firstName = 'First Name must be letters only, min 2 characters';
    }
    if (values.lastName && !nameRegex.test(values.lastName)) {
      errors.lastName = 'Last Name must be letters only, min 2 characters';
    }
    if (values.facilityName && !nameRegex.test(values.facilityName)) {
      errors.facilityName = 'Facility Name must be letters only, min 2 characters';
    }

    if (!values.npi && !values.taxId) {
      const errorMsg = 'Please provide a TIN and/or an NPI';
      errors.npi = errorMsg;
      errors.taxId = errorMsg;
    }

    if (values.npi && !/^\d{10}$/.test(values.npi)) {
      errors.npi = 'NPI must be a 10-digit number';
    }
    if (values.taxId && !/^\d{9}$/.test(values.taxId)) {
      errors.taxId = 'TIN must be a 9-digit number';
    }

    const phoneNumber = values.phone.replace(/[^\d]/g, '');
    if (phoneNumber.length > 0 && phoneNumber.length !== 10) {
      errors.phone = 'Phone number must be 10 digits';
    }
    return errors;
  };

  const formatPhoneNumberForDisplay = (input: string | undefined) => {
    if (!input) return '';
    let formatted = '';
    if (input.length > 3) {
      formatted = `(${input.slice(0, 3)}) `;
      if (input.length > 6) {
        formatted += `${input.slice(3, 6)}-${input.slice(6)}`;
      } else {
        formatted += `${input.slice(3)}`;
      }
    } else {
      formatted = input;
    }
    return formatted;
  };

  const handleSubmit = (values:requestingproviderprops) => {
    setrequestingProviderItem(values);
    onClose();
  };

  const ErrorMessage:React.FC<{ errors: FormikErrors<FormValues>; fieldName: string }> = ({ errors, fieldName }) => {
    const errorMessage = errors[fieldName];
    const dataId = `${fieldName}-error`;
    return typeof errorMessage === 'string' ? <div className="errorMessage" data-testid={dataId}>{errorMessage}</div> : null;
  };

  return ReactDOM.createPortal(
    <div className="modal fade show requestingProvidermodal" data-testid="requestingProviderModal" aria-modal="true" tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header shadow-sm">
            <h5 className="modal-title">Edit Requesting Provider for Service 1</h5>
            <button type="button" className="btn-close btn-sm btnClose" aria-label="Close" onClick={() => onClose()} />
          </div>
          <div className="modal-body">
            <Formik initialValues={item} validationSchema={validationSchema} validate={validate} validateOnMount onSubmit={handleSubmit}>
              {({ setFieldValue, errors, values }) => (
                <Form>
                  <div className="form-group" id="r-provider-procedure" data-testid="providermodal" style={{ display: 'block' }}>
                    {/* <!--tin rp-npi div start--> */}

                    <div className="row align-items-center">
                      <div className="col-5">
                        <label className="fw-bold mb-0" htmlFor="rp-tin">TIN</label>
                        <Field name="taxId">
                          {({ field, form }: FieldProps<string, any>) => (
                            <input
                              {...field}
                              type="text"
                              data-testid="taxId-input"
                              id="rp-tin"
                              value={taxId}
                              onChange={(event:any) => handleTaxId(event, form)}
                              className={`form-control inputField ${errors.taxId ? 'inputFieldError' : ''}`}
                            />
                          )}
                        </Field>
                        <ErrorMessage errors={errors} fieldName="taxId" />
                      </div>
                      <div className="col fw-bold fs-sm mb-0 pt-2 text-center text-muted ">
                                                    &nbsp;and/or
                      </div>
                      <div className="col-6 ">
                        <label className=" fw-bold mb-0" htmlFor="rp-npi">NPI</label>
                        <Field name="npi">
                          {({ field, form }: FieldProps<string, any>) => (
                            <input
                              {...field}
                              type="text"
                              data-testid="npi-input"
                              id="rp-npi"
                              value={npi}
                              onChange={(event:any) => handleNpi(event, form)}
                              className={`form-control inputField ${errors.npi ? 'inputFieldError' : ''}`}
                            />
                          )}
                        </Field>
                        <ErrorMessage errors={errors} fieldName="npi" />
                      </div>
                    </div>
                    {/* <!--tin rp-npi div end--> */}
                    {/* <!--rp-name div start--> */}
                    <div className="form-group mt-3" aria-required="true">
                      <div className="row align-items-center">
                        <div className="col-3">
                          <label className="fw-bold mb-0" htmlFor="rp-first-name">First Name</label>
                          <Field
                            type="text"
                            data-testid="firstname-input"
                            id="rp-first-name"
                            name="firstName"
                            className={`form-control inputField ${errors.firstName ? 'inputFieldError' : ''}`}
                          />
                          <ErrorMessage errors={errors} fieldName="firstName" />
                        </div>
                        <div className="col-4">
                          <label className="fw-bold mb-0" htmlFor="rp-lastname-field">Last Name</label>
                          <Field
                            type="text"
                            data-testid="lastname-input"
                            id="rp-lastname-field"
                            name="lastName"
                            className={`form-control inputField ${errors.lastName ? 'inputFieldError' : ''}`}
                          />
                          <ErrorMessage errors={errors} fieldName="lastName" />
                        </div>
                        <div className="col-1 fw-bold fs-sm mb-0 pt-2 text-center text-muted ">
                                                        &nbsp;or
                        </div>
                        <div className="col-4">
                          <label className="fw-bold mb-0" htmlFor="rp-facilityname-field">Facility Name</label>
                          <Field
                            type="text"
                            data-testid="groupName-input"
                            id="rp-facilityname-field"
                            name="facilityName"
                            className={`form-control inputField ${errors.facilityName ? 'inputFieldError' : ''}`}
                          />
                          <ErrorMessage errors={errors} fieldName="facilityName" />
                        </div>
                      </div>
                    </div>
                    {/* <!--rp-name div end--> */}
                    <div className="form-group rp-address mt-3">
                      <div className="mb-3">
                        <label className=" fw-bold mb-0" htmlFor="rp-address-1">Address Line 1</label>
                        <Field
                          type="text"
                          data-testid="address-input"
                          id="rp-address-1"
                          name="address"
                          className={`form-control inputField ${errors.address ? 'inputFieldError' : ''}`}
                        />
                        <ErrorMessage errors={errors} fieldName="address" />
                      </div>
                      <div className="mb-3">
                        <label className=" fw-bold mb-0" htmlFor="rp-address-2">Address Line 2</label>
                        <Field
                          type="text"
                          id="rp-address-2"
                          name="address2"
                          className={`form-control inputField ${errors.address2 ? 'inputFieldError' : ''}`}
                        />
                        <ErrorMessage errors={errors} fieldName="address2" />
                      </div>
                      <div className="mb-3">
                        <label className="fw-bold mb-0" htmlFor="rp-city">City</label>
                        <Field
                          type="text"
                          data-testid="city-input"
                          id="rp-city"
                          name="city"
                          className={`form-control inputField ${errors.city ? 'inputFieldError' : ''}`}
                        />
                        <ErrorMessage errors={errors} fieldName="city" />
                      </div>
                      <div className="mb-3">
                        <label className="fw-bold mb-0" htmlFor="rp-state">State</label>
                        <Field
                          as="select"
                          data-testid="state-input"
                          name="state"
                          className={errors.state ? 'selectStateError' : 'selectState'}
                        >
                          <option value="">Select a state</option>
                          {states.map((state) => (
                            <option key={state.value} value={state.value}>
                              {state.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage errors={errors} fieldName="state" />
                      </div>
                      <div className="mb-3">
                        <label className="fw-bold mb-0" htmlFor="rp-zipcode">Zip/Postal Code</label>
                        <Field
                          type="text"
                          data-testid="zipCode-input"
                          id="rp-zipcode"
                          name="zipCode"
                          className={`form-control inputField ${errors.zipCode ? 'inputFieldError' : ''}`}
                        />
                        <ErrorMessage errors={errors} fieldName="zipCode" />
                      </div>
                      <div className="mb-3">
                        <label className="fw-bold mb-0" htmlFor="rp-phoneNumber">Phone Number</label>
                        <Field
                          type="text"
                          id="rp-phoneNumber"
                          data-testid="phone-input"
                          name="phone"
                          className={`form-control inputField ${errors.phone ? 'inputFieldError' : ''}`}
                          placeHolder="###-###-####"
                          value={formatPhoneNumberForDisplay(values.phone)}
                          onChange={(e:any) => {
                            const formatted = e.target.value.replace(/[^\d]/g, '');
                            setFieldValue('phone', formatted);
                          }}
                        />
                        <ErrorMessage errors={errors} fieldName="phone" />
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <button className="btn btn btn-primary rounded-pill mr-2 px-4" type="submit" data-testid="save">
                      Save
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default RequestingProviderModal;
